export const isIncluded = <T extends { id: string }>(
  item: T,
  arr: T[],
): boolean => {
  return arr.some((includedItem) => includedItem.id === item.id);
};

export function arrayOrUndefined<T>(arr?: T[] | null) {
  return arr?.length ? arr : undefined;
}

export const firstItemAndLength = (arr: string[]): string => {
  if (arr.length > 1) {
    return `${arr[0]} +(${arr.length - 1})`;
  }
  if (arr.length === 1) {
    return arr[0];
  }
  return "";
};

export const isStringArray = (arr: unknown[]): arr is string[] => {
  return arr.every((item) => typeof item === "string");
};
